<template>
  <Bundle>
    <div class="flex flex-col justify-between gap-8 lg:flex-row">
      <div class="flex flex-col gap-4">
        <div>
          <RevIllustration
            :alt="i18n(translations.illustrationAlternative)"
            :height="21"
            src="/img/insurance/backUpLogo.svg"
            :width="96"
          />
        </div>
        <div class="text-static-default-hi body-1-bold">
          {{ insuranceOffer.title }}
        </div>
        <RevLink
          target="_blank"
          :to="i18n(translations.faqLinkValue)"
          :tracking="{
            name: 'insurance_faq',
            zone: 'cart_insurance_selected',
            offer_id: props.insuranceOffer.id,
          }"
        >
          <div class="text-static-default-low body-2-link">
            {{ i18n(translations.faqLink) }}
          </div>
        </RevLink>
      </div>

      <div class="flex flex-row items-end justify-between gap-8 lg:flex-col">
        <div class="text-static-default-hi heading-3">
          {{ i18n.price(insuranceOffer.price) }}
        </div>
        <RevButton
          size="small"
          variant="secondaryDestructive"
          @click="removeOffer"
        >
          {{ i18n(translations.remove) }}
        </RevButton>
      </div>
    </div>

    <div class="mt-12 md:mt-8">
      <InsuranceCompliancy
        id="selected-offer-catchup"
        :disabled
        :offer="insuranceOffer"
        @update="handleCompliancyCheckboxUpdate"
      />
    </div>
  </Bundle>
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import InsuranceCompliancy from '~/scopes/insurance/components/InsuranceCompliancy/InsuranceCompliancy.vue'

import Bundle from '../../../Bundle/Bundle.vue'

import translations from './SelectedCatchUpOffer.translations'

const props = defineProps<{
  insuranceOffer: InsuranceOffer
  disabled: boolean
}>()

const emit = defineEmits<{
  'update-compliancy': [updatedOffer: InsuranceOffer]
  remove: []
}>()

const i18n = useI18n()

function handleCompliancyCheckboxUpdate(insuranceOffer: InsuranceOffer) {
  emit('update-compliancy', insuranceOffer)
}

const tracking = useTracking()

function removeOffer() {
  tracking.trackClick({
    name: 'remove_insurance_from_cart',
    zone: 'cart_insurance_selected',
    offer_id: props.insuranceOffer.id,
  })

  emit('remove')
}
</script>
